import React, {useState} from 'react';

import * as S from './GoStreakCircleProgress.style';

import HappyGoIcon from '@stencil/icons/src/HappyGoIconGoStreak/HappyGoIconGoStreak';

function convertStayToPercent(stay) {
  switch (stay) {
    case 1:
      return 25;
    case 2:
      return 40;
    case 3:
      return 60;
    case 4:
      return 75;
    default:
      return 0;
  }
}

const GoStreakCircleProgress = ({
  sqSize,
  strokeWidth,
  completedBookings = 0,
  inProgressBookings = 0,
  maxBookings = 5,
  showTracker = false,
}) => {
  const totalBookings = completedBookings + inProgressBookings;
  const [percentage, setPercent] = useState(convertStayToPercent(totalBookings));
  // Size of the enclosing square
  // SVG centers the stroke width on the radius, subtract out so circle fits in square
  const radius = (sqSize - strokeWidth) / 2;
  // Enclose cicle in a circumscribing square
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  // Arc length at 100% coverage is the circle circumference
  const dashArray = radius * Math.PI * 2;
  // Scale 100% coverage overlay with the actual percent
  const dashOffset = dashArray - (dashArray * percentage) / 100;

  if (!showTracker) {
    return null;
  }

  return (
    <S.GoStreakWrapper>
      <svg width={sqSize} height={sqSize} viewBox={viewBox}>
        <circle
          className="circle-background"
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius}
          strokeWidth={`${strokeWidth}px`}
        />
        <circle
          className="circle-progress"
          cx={sqSize / 2}
          cy={sqSize / 2}
          r={radius}
          strokeWidth={`${strokeWidth}px`}
          // Start progress marker at 12 O'Clock
          transform={`rotate(90 ${sqSize / 2} ${sqSize / 2})`}
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset,
          }}
        />
      </svg>
      <div className="iconWrapper">
        <HappyGoIcon width="1.5rem" height="1rem" />
      </div>
      {totalBookings > 0 && totalBookings <= maxBookings && (
        <p className="textWrapper">
          {totalBookings}/{maxBookings}
        </p>
      )}
    </S.GoStreakWrapper>
  );
};

export default GoStreakCircleProgress;
